import React from 'react';
import { OverlayTrigger, PopOver } from '@tencent/spaui';
import Icon from '@tencent/od-icon';
import './index.scoped.less';

const TipIcon = (props: {
  value?: any;
  children: any;
  overlayTriggerProps?: Record<string, any>;
  popOverProps?: Record<string, any>;
  iconProps?: Record<string, any>;
}) => {
  const { value = null, children, iconProps = {}, overlayTriggerProps = {}, popOverProps = {} } = props;

  return <>
    {value}
    {!!children && <OverlayTrigger
      placement="bottom"
      alignment="left"
      {...overlayTriggerProps}
      overlay={
        <PopOver {...popOverProps} className={`tip-icon-popover ${popOverProps.className || ''}`}>{children}</PopOver>
      }
    >
      <Icon
        className="tip-icon"
        name="question-filled"
        {...iconProps}
      />
    </OverlayTrigger>}
  </>;
};

export default TipIcon;
